import { useEffect } from "react";

export default function ReferrerDebugger() {
  useEffect(() => {
    const ref = document.referrer || "(no referrer provided)" ;
    const ref1 =  document.URL ||"(no referrer provided URL)" ;
    const params = new URLSearchParams(window.location.search);

    console.log("Browser Referrer:", ref);
    console.log("Browser Referrer URL:", ref1);
    console.log("From UTM (if any):", {
      source: params.get("utm_source"),
      medium: params.get("utm_medium"),
      campaign: params.get("utm_campaign")
    });

    // Optionally send to RudderStack explicitly
    if (window.rudderanalytics) {
      window.rudderanalytics.page({
        context: {
          page: {
            referrer: ref
          }
        }
      });
    }
  }, []);

  return null; // no UI needed, just debugging
}
